import React, { ReactElement } from 'react';
import { Alert, AlertColor, AlertProps, styled } from '@mui/material';
import { CheckSuccessIcon, ErrorIcon, InformationOutlinedIcon, WarningIcon } from '@synergy/theme-next';

const StyledAlert = styled(Alert)(({ theme }) => ({
    ...theme.typography.body2,
    '& .MuiAlert-icon': {
        color: theme.palette.text.primary,
    },
}));

export const PoolBanner = (props: AlertProps): ReactElement => {
    const { variant = 'filled', severity = 'info', children } = props;
    const iconMapping: Partial<Record<AlertColor, React.ReactNode>> = {
        error: <ErrorIcon />,
        info: <InformationOutlinedIcon />,
        success: <CheckSuccessIcon />,
        warning: <WarningIcon />,
    };

    return (
        <StyledAlert variant={variant} severity={severity} iconMapping={iconMapping} {...props}>
            {children}
        </StyledAlert>
    );
};
